var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import AonPannel from "../../components/core/AonPannel";
import { UuiSpinner } from "@aonunited/react";
import { AonButton } from "../../components/core/AonButton";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
import { getApplicationConfig, getDDMMYYYY } from "../../constants/utilities";
import { getMarketAndResearchDataForSpecificMarket } from "../../api/marketAndResearch";
import { MarketNewsDailog } from "../Dailog/MarketNewsDailog";
import AonAgGridTable from "../../components/core/AonAgGridTable/table";
export var MarketNewsAndResearchpan = function (props) {
    var id = props.id;
    var _a = useState(false), marketNewsLoader = _a[0], setMarketNewsLoader = _a[1];
    var _b = useState([]), MarketNewsMatrix = _b[0], setMarketNewsMatrix = _b[1];
    var _c = useState(false), errorMarketSpecific = _c[0], setErrorMarketSpecific = _c[1];
    var _d = React.useState(false), showPublicationDailog = _d[0], setShowPublicationDailog = _d[1];
    var _e = React.useState(""), publicationId = _e[0], setPublicationId = _e[1];
    var applicationConfig = getApplicationConfig();
    useEffect(function () {
        fetchMarketNewsAndResearch();
    }, []);
    var fetchMarketNewsAndResearch = function () { return __awaiter(void 0, void 0, void 0, function () {
        var marketNewsResearchRes, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setMarketNewsLoader(true);
                    return [4 /*yield*/, getMarketAndResearchDataForSpecificMarket({
                            MarketIds: id,
                            PreViewReViewGuideMode: applicationConfig.applicationId,
                        })];
                case 2:
                    marketNewsResearchRes = _a.sent();
                    setMarketNewsMatrix(marketNewsResearchRes.value);
                    setMarketNewsLoader(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setMarketNewsLoader(false);
                    setErrorMarketSpecific(true);
                    console.log("error", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handlePulicationDailog = function () {
        setShowPublicationDailog(!showPublicationDailog);
    };
    var onMarketTitleClick = function (id) {
        var data = MarketNewsMatrix[id];
        setPublicationId(data.publicationId);
        handlePulicationDailog();
    };
    var MarketTypeSpecificBody = function () {
        return marketNewsLoader ?
            React.createElement("div", { style: { display: "flex", alignItems: "center", width: "800px" } },
                React.createElement(UuiSpinner, { style: { marginLeft: "auto" }, variant: "small" })) : !errorMarketSpecific ?
            React.createElement("div", null,
                React.createElement(AonAgGridTable, { height: 400, rowData: MarketNewsMatrix, columns: columns(onMarketTitleClick), loading: false, pagination: false }),
                showPublicationDailog && React.createElement(MarketNewsDailog, { publicationId: publicationId, onClickClose: handlePulicationDailog, showDialog: showPublicationDailog }))
            :
                React.createElement("div", null,
                    React.createElement(AonButton, { style: { paddingInline: "5px" }, variant: BUTTON_VARIANT.TEXT, onClick: function () { return fetchMarketNewsAndResearch(); } }, "Retry"));
    };
    return (!marketNewsLoader && !MarketNewsMatrix.length) ? null : React.createElement(AonPannel, { headerTitle: "Market News and Research", Body: React.createElement(MarketTypeSpecificBody, null) });
};
export var columns = function (onMarketTitleClick) {
    var PublicationDate = function (info) {
        return React.createElement("span", null, getDDMMYYYY(new Date(info.getValue())));
    };
    var PulicationHeadline = function (info) { return React.createElement("span", { onClick: function (event) {
            event.preventDefault();
            onMarketTitleClick(info.node.rowIndex);
        }, style: { minWidth: "600px", fontWeight: "bold", color: "#007585", cursor: "pointer" } }, info.getValue()); };
    return [
        { field: "publicationDate", cellRenderer: PublicationDate, headerName: "Date", sortable: false, flex: 0.5, minWidth: 100 },
        { field: "publicationHeadline", cellRenderer: PulicationHeadline, headerName: "Title", sortable: false, flex: 2, minWidth: 200 },
    ];
};
